import React from 'react';

import styles from './Paragraph.module.scss';

interface ParagraphProps {
  children: string;
}

export const Paragraph = ({ children }: ParagraphProps) => {
  return (
    <div className={styles.paragraph} data-testid="mre-popup-paragraph">
      {children}
    </div>
  );
};
